import axios from "axios";

 
// export const apiURL = "http://localhost:8000"; //palitan sa deployment
export const apiURL = "https://api.ltohrdos.com"; //ito gagamitin sa deployment

export const api = axios.create({
  baseURL: `${apiURL}/api`,
  withCredentials: true, // Crucial: Tells the browser to send HttpOnly cookies
});

export const externalApi = axios.create();

// This tells Laravel Echo to use THIS configured Axios instance 
// when trying to connect to the WebSocket server.
window.axios = api; 

// REQUEST INTERCEPTOR
api.interceptors.request.use(
  (config) => {
    // The Bearer token logic is removed here. The browser automatically 
    // handles attaching the HttpOnly cookie for auth.

    // Ensure we always expect a JSON response from the API
    if (!config.headers.Accept) {
        config.headers.Accept = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => response,
  (error) => {
    
    // 1. Handle 401 Unauthorized (Expired Session)
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized! Session may be expired.");
      
      // Clear your UI user state instead of the token
      localStorage.removeItem("hrdos_user");
      
      // Redirect to login page if they aren't already there
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
          window.location.href = '/login';
      }
    }

    // 2. Catch the 403 Force Password Change Exception
    if (error.response && error.response.status === 403) {
      if (error.response.data.error === 'force_password_change_required') {
        console.log("Forced password change triggered. Opening modal...");
        
        // Dispatch a custom event that your Vue layout/component can listen for globally
        window.dispatchEvent(new CustomEvent('open-force-password-modal'));
      }
    }

    return Promise.reject(error);
  }
);

export default api;